module.exports = __webpack_public_path__ + "img/fuel.80f273fc.svg";